import React from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '../../../../themed/images/sendity_logo_other.svg';
import useLanguaje from '../../../../hooks/useLanguaje';

function Logotype() {
  const { t } = useTranslation();
  const { valueLang } = useLanguaje();

  const href =
    valueLang?.value === 'es' ? 'https://www.sendity.com/' : 'https://www.sendity.com/en/';
  return (
    <div className="col-md-5 step_sec_left d-flex align-items-center justify-content-center">
      <a href={href} className="">
        <img src={Logo} alt={t('Logo Sendity')} />
      </a>
    </div>
  );
}
export default Logotype;
